module.exports = __webpack_public_path__ + "img/settings-add-connection-screenshot-phone-frame-with-shadow.777972b9.png";